<template>
    <section class="section section--map-area hero">
        <div class="map-country-selector spring">
            <div class="map-area--text vtop-cell">
                <h3 class="heading heading--3 heading--light">Oferte Roaming</h3>
                <p>&nbsp;</p>

                <p>Unde mergi?</p>
                <input placeholder="e.g. Franța" type="text" v-model="countryInput" @keypress.enter="handleSearchEnter" autocomplete="off" />
                <div class="country-none" v-show="matchedCountries.length === 0 && countryInput !== ''">Nu s-au găsit rezultate pentru "{{ countryInput }}"</div>
                <ul class="matched-countries">
                    <li v-for="(item, index) in matchedCountries" :key="item.name" v-if="index <= limitationList">
                        <router-link :to="{ name: 'destinatie', params: { country: item.nameClean, service: checkUrlCartela, travelTime: 'inainte-de-calatorie' } }">{{ item.name }}</router-link>
                    </li>
                </ul>

                <p>Destinații populare</p>
                <ul class="popular-countries">
                    <li v-for="(item, index) in $root.popularCountries" :key="index">
                        <router-link :to="{ name: 'destinatie', params: { country: $root.countries[item].nameClean, service: checkUrlCartela, travelTime: 'inainte-de-calatorie' } }">
                            {{ $root.countries[item].name }}
                        </router-link>
                    </li>
                </ul>
            </div>
            <!-- start roaming map -->
            <div class="roaming-map" id="mapContainer">
                <div class="map"></div>
                <div class="country-popup-box text-center" :class="{ 'is-visible': popperVisible }">
                    <div v-if="selectedCountryInPopup">
                        <a href="javascript:;" class="close"></a>
                        <p v-text="selectedCountryInPopup.name"></p>
                        <router-link :to="{ name: 'destinatie', params: { country: selectedCountryInPopup.nameClean, service: checkUrlCartela, travelTime: 'inainte-de-calatorie' } }" class="button button--primary button--inline no-gutter--bottom"> Vezi oferte și tarife </router-link>
                    </div>
                </div>
            </div>
            <!-- end roaming map -->
        </div>
    </section>
</template>
<script>
import H from './../modules/helpers.js';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
    name: 'MapContainer',
    data() {
        return {
            countryInput: '',
            matchedCountries: [],
            limitationList: 2,
            selectedCountryInPopup: null,
            popperCountry: null,
            popperVisible: false,
            checkUrlCartela: '',
        };
    },
    watch: {
        countryInput: function (value, oldValue) {
            var matchedCountries = [];
            if (value !== '') {
                this.$root.countries.forEach((country) => {
                    if (H.removeAccents(country.name.toLowerCase()).indexOf(H.removeAccents(value.toLowerCase())) !== -1) {
                        matchedCountries.push(country);
                    }
                });
            }
            this.matchedCountries = matchedCountries;
        },
    },
    methods: {
        handleSearchEnter() {
            if (this.matchedCountries.length === 1) {
                this.$router.push({
                    name: 'destinatie',
                    params: {
                        country: this.matchedCountries[0].nameClean,
                        service: this.checkUrlCartela,
                        travelTime: 'inainte-de-calatorie',
                    },
                });
            }
        },
        hidePopper() {
            this.popperVisible = false;
        },
    },
    mounted: function () {
        var $this = this;

        this.$nextTick(function () {
            if (window.location.href.indexOf('info=cartela') != -1 || window.location.href.indexOf('/#/?info=cartela') != -1) {
                this.checkUrlCartela = 'cartela';
            } else {
                this.checkUrlCartela = 'abonament';
            }
            // Mapael initialisation
            var world = $('.roaming-map');
            world.mapael({
                map: {
                    name: 'world_countries',
                    defaultArea: {
                        attrs: {
                            fill: '#5d5d5d',
                            stroke: '#333333',
                            'stroke-width': 0.3,
                        },
                        attrsHover: {
                            fill: '#bb1227',
                        },
                    },
                    buttons: {
                        reset: {
                            cssClass: 'roaming-map__control roaming-map__control--reset',
                        },
                        in: {
                            cssClass: 'roaming-map__control roaming-map__control--in',
                        },
                        out: {
                            cssClass: 'roaming-map__control roaming-map__control--out',
                        },
                    },
                    zoom: {
                        enabled: true,
                        step: 1,
                        maxLevel: 20,
                    },
                },
            });

            var level = 0,
                selectorHide = $('.map-area--text');

            $('.zoomButton.zoomIn').on('click', function (e) {
                level = level + 1;

                if (level >= 1) {
                    selectorHide.addClass('hidden');
                }
            });
            $('.zoomButton.zoomReset').on('click', function (e) {
                level = 0;
                selectorHide.removeClass('hidden');
            });
            $('.zoomButton.zoomOut').on('click', function (e) {
                if (level <= 0) {
                    return false;
                } else {
                    level = level - 1;
                }

                if (level == 0) {
                    selectorHide.removeClass('hidden');
                }
            });

            if (level > 1) {
                selectorHide.addClass('hidden');
                console.log(level);
            } else {
                selectorHide.removeClass('hidden');
            }

            var country_popup = $('.country-popup-box');

            $('path').on('click.mapPopper', function () {
                var ref = this;
                var countryID = this.getAttribute('data-id');

                var foundCountry = $this.$root.countries.find((country) => {
                    return country.countryCodeISO === countryID;
                });

                if (foundCountry) {
                    $this.selectedCountryInPopup = foundCountry;
                    $this.popperVisible = true;
                }

                window.ref = ref;

                if (foundCountry.countryCodeISO === 'US') {
                    new Popper(ref, country_popup, {
                        placement: 'top',
                        onCreate: function (data) {},
                        modifiers: {
                            offset: {
                                enabled: true,
                                offset: '-210px, -200px',
                            },
                        },
                    });
                } else {
                    new Popper(ref, country_popup, {
                        placement: 'top',
                        onCreate: function (data) {},
                        modifiers: {
                            offset: {
                                enabled: true,
                                // offset: '0px, -50px'
                            },
                        },
                    });
                }
            });

            $('path').on('mouseenter', function () {
                var t = this,
                    NameOfCountry;

                var getAttribute = t.getAttribute('data-id');
                var foundCountryOnHover = $this.$root.countries.find((country) => {
                    return country.countryCodeISO === getAttribute;
                });
                if (foundCountryOnHover) {
                    NameOfCountry = foundCountryOnHover.name;
                    tippy(t, {
                        content: '' + NameOfCountry + '',
                    });
                }
            });

            $(document).on('click.mapPopper', function (e) {
                var elem = $(e.target);
                if (!elem.is('path') && $this.popperVisible) {
                    $this.hidePopper();
                }
            });

            $('.country-popup-box.close').on('click.mapPopper', function (e) {
                $this.hidePopper();
            });
        });
    },

    beforeDestroy() {
        $(document).off('click.mapPopper');
    },
};
</script>
